
import ViaCepService from "@/services/ViaCepService";
import IBGEService from "@/services/IBGEService";
import Vue from "vue";

export default Vue.extend({
  name: "CadastroEnderecoDialog",
  props: {
    enderecoCadastro: {
      type: Object,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
      default: true,
    },
    closeBtn: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    isLoading: false,

    lookups: {
      estados: [] as string[],
      municipios: [] as string[],
      paises: [] as string[],
    },

    uf_mask: [/[A-Z]/],

    cep: "",
    logradouro: "",
    complemento: "",
    numero: "",
    bairro: "",
    cidade: "",
    uf: "",
    pais: "",
  }),

  watch: {
    enderecoCadastro: {
      immediate: true,
      deep: true,
      handler: function () {
        this.cep = this.enderecoCadastro?.cep || "";
        this.logradouro = this.enderecoCadastro?.logradouro || "";
        this.complemento = this.enderecoCadastro?.complemento || "";
        this.numero = this.enderecoCadastro?.numero || "";
        this.bairro = this.enderecoCadastro?.bairro || "";
        this.cidade = this.enderecoCadastro?.cidade || "";
        this.uf = this.enderecoCadastro?.uf || "";
        this.pais = this.enderecoCadastro?.pais || "";

        if (!this.editable) {
          // adiciona os items nos lookups
          if (!this.lookups.estados.includes(this.uf))
            this.lookups.estados.push(this.uf);
          if (!this.lookups.paises.includes(this.pais))
            this.lookups.paises.push(this.pais);
          if (!this.lookups.municipios.includes(this.cidade))
            this.lookups.municipios.push(this.cidade);
        }

        const form = this.$refs.formCadastro as Vue & {
          resetValidation: () => void;
        };
        form?.resetValidation();
      },
    },
    cep: {
      handler: function (val) {
        if (val.length === 9) {
          this.searchCep();
        }
      },
    },
    uf: {
      async handler() {
        if (this.uf == "EX" || !this.editable) return;
        if (this.uf != "EX" && this.pais != "Brasil") {
          this.pais = "Brasil";
        }

        this.lookups.municipios = await IBGEService.getMunicipiosByUF(
          this.uf
        ).then((municipios) => {
          if (
            !municipios?.some(
              (municipio) =>
                municipio.nome?.toLowerCase() === this.cidade?.toLowerCase()
            )
          ) {
            this.cidade = "";
          }

          return municipios?.map((municipio) => municipio.nome) || [];
        });
      },
    },
    pais: {
      async handler() {
        if (!this.editable) return;
        if (this.pais != "Brasil") {
          this.uf = "EX";
          this.cidade = "";
        }
      },
    },
  },
  async mounted() {
    if (!this.editable) return;
    this.lookups = {
      estados: await IBGEService.getUFs().then(
        (ufs) => ufs?.map((uf) => uf.sigla) || []
      ),
      paises: await IBGEService.getPaises(),
      municipios: [],
    };
  },
  methods: {
    searchCep() {
      if (!this.editable) return;
      this.isLoading = true;
      ViaCepService.getCep(this.cep)
        .then((response) => {
          this.isLoading = false;
          this.logradouro = response.logradouro;
          this.complemento = response.complemento;
          this.bairro = response.bairro;
          this.cidade = response.localidade;
          this.uf = response.uf;
          this.pais = "Brasil";
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit("close");
    },
    validateCadastro() {
      const form = this.$refs.formCadastro as Vue & { validate: () => boolean };
      if (!form.validate()) return;

      this.$emit("cadastro", {
        cep: this.cep,
        logradouro: this.logradouro,
        complemento: this.complemento,
        numero: this.numero,
        bairro: this.bairro,
        cidade: this.cidade,
        uf: this.uf,
        pais: this.pais,
      });
    },
  },
});
